import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import cn from 'classnames';
import { globalStore } from '../../global.store';
import { cardsblockStore } from '../cardsblock/cardsblock.store';
import useTabVisibility from '../../hooks/useTabVisibility';
import { Logo } from '../../ui/logo/logo';
// import Button from '../../ui/button';
import './openInApp.scss';
import { useRef } from 'react';

const OpenInApp = observer(() => {
  const { openInAppData, setOpenInAppData } = cardsblockStore;
  const navigate = useNavigate();
  let timeId: any = useRef(null);

  const clearTimer = () => {
    clearTimeout(timeId.current);
  }

  const goBack = () => {
    navigate('/');
    setOpenInAppData(null);
  };

  const interval = () => {
    const webFallback = 'https://apps.apple.com/am/app/yodoor/id6742641933';
    if (isTabActive) {
      window.location.href = webFallback;
    } else {
      clearTimer();
    }
  };

  const deepLinkUri = () => {
    timeId.current = setTimeout(interval, 2000);

    const appLink = `yc://openapp?command=LoginAndOpenRoom&roomId=${openInAppData.id}&userToken=${globalStore.userData.token}`;

    window.location.href = appLink;
  };

  const { isTabActive } = useTabVisibility(clearTimer);

  return (
    <div
      className={cn('openInAppContainer', {
        withoutImg: !!openInAppData?.previewImage,
      })}
    >
      <i className="icon-goBack" onClick={goBack} />
      {!!openInAppData?.previewImage && (
        <img
          src={openInAppData.previewImage}
          alt="Loader"
          className="openInAppImage"
        />
      )}
      <div className="openInAppWrapper">
        <div className="openInAppBody">
          <div className="openInAppLogo">
            <Logo name="cerebrum" type="svg" />
          </div>
          <span className="openActiveText">
            {isTabActive ? 'active' : 'inActive'}
          </span>
          <span className="openInAppText">
            Open application to join this space{isTabActive ? '' : '.'}
          </span>
          <button className="openInAppButton" onClick={deepLinkUri}>
            Open in app
          </button>
          {/*<Button*/}
          {/*  onClick={() => {*/}
          {/*    setOpenInAppData(null);*/}
          {/*    navigate(`room/${openInAppData.id}`, {*/}
          {/*      state: {*/}
          {/*        runInMobile: true,*/}
          {/*      },*/}
          {/*    });*/}
          {/*  }}*/}
          {/*  color="secondaryNeutral"*/}
          {/*  size="lg w100"*/}
          {/*  type="rounded-30"*/}
          {/*>*/}
          {/*  Skip*/}
          {/*</Button>*/}
        </div>
      </div>
    </div>
  );
});

export default OpenInApp;
